import React, { useMemo, useState } from "react";
import { useController } from "react-hook-form";
import { CCollapse } from "@coreui/react";

export const AccessPermissions = ({ control, canUpdateLocations, allPermissions }) => {
  const [permissionTypeKey, setPermissionTypeKey] = useState("");
  const [currentGroupName, setCurrentGroupName] = useState("");

  const { field: locations } = useController({ control, name: "clubready_store_ids" });

  const onPermissionTypeClick = (type) => {
    setPermissionTypeKey(type);

    if (type === permissionTypeKey) {
      setPermissionTypeKey("");
      setCurrentGroupName("");
    }
  };

  const onGroupPermissionClick = (e) => {
    let targetText = e.target.innerText;
    let label = e.target.parentElement.dataset.label;
    let groupName = label ? label + "-" + targetText : targetText;

    if (groupName === currentGroupName) {
      setCurrentGroupName("");
      return;
    }

    setCurrentGroupName(groupName);
  };

  const onPermissionClick = (e, state) => {
    e.stopPropagation();
    let checked = e.target.checked;
    let val = +e.target.value;

    if (!checked) {
      delete state.value[val];
      state.onChange(state.value);
      return;
    }

    state.onChange({ ...state.value, [val]: checked });
  };

  const onAllClick = ({ e, options, state }) => {
    let currentPermissions = options.map((p) => p.id);
    let checked = e.target.checked;

    if (checked) {
      let ids = currentPermissions.reduce((acc, val) => ({ ...acc, [val]: true }), {});
      state.onChange({ ...state.value, ...ids });
    } else {
      for (let key in state.value) {
        if (currentPermissions.includes(+key)) {
          delete state.value[key];
        }
      }

      state.onChange(state.value);
    }
  };

  const isAllChecked = (options, state) => {
    let allPermissionIdsPerGroup = options.map((permission) => permission.id);
    return allPermissionIdsPerGroup.every((id) => state.value[id]);
  };

  const renderInnerControls = ({ id, group, options, state }) => (
    <>
      <p style={{ fontWeight: "bold" }}>
        Selected Locations: {options.filter((option) => state.value[option.id]).length}
      </p>
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ paddingLeft: "40px", paddingBottom: "15px", width: "100%" }}
      >
        <div className="form-check" key={group}>
          <input
            className="form-check-input"
            type="checkbox"
            value={group}
            id={id ? id : group}
            onChange={(e) => onAllClick({ e, options, state })}
            checked={isAllChecked(options, state)}
          />
          <label className="form-check-label" htmlFor={id ? id : group}>
            Check All / Uncheck All
          </label>
        </div>

        {options.map((permission) => (
          <div className="form-check" key={permission.id}>
            <input
              className="form-check-input"
              type="checkbox"
              value={permission.id}
              id={permission.id}
              onChange={(e) => onPermissionClick(e, state)}
              checked={state.value[permission.id] ?? false}
            />
            <label className="form-check-label" htmlFor={permission.id}>
              {permission.name}
            </label>
          </div>
        ))}
      </div>
    </>
  );

  const locationOptions = allPermissions.location_permissions || [];
  const locationOptionsKey = locationOptions.map((location) => location.id).join(",");
  const reorderedLocations = useMemo(() => {
    let selected = [];
    let rest = [];

    for (let location of locationOptions) {
      if (locations.value[location.id]) {
        selected.push(location);
      } else {
        rest.push(location);
      }
    }

    return [...selected, ...rest];
  }, [locationOptionsKey]);

  const renderGroups = (groupParent) => (
    <div onClick={(e) => onGroupPermissionClick(e)}>
      <CCollapse show={groupParent === permissionTypeKey}>
        {renderInnerControls({
          group: groupParent,
          options: reorderedLocations,
          state: locations
        })}
      </CCollapse>
    </div>
  );

  if (!canUpdateLocations) return null;

  return (
    <div className="light group">
      <div className="group__item" onClick={() => onPermissionTypeClick("location_permissions")}>
        Choose Location Permissions
      </div>
      {renderGroups("location_permissions")}
    </div>
  );
};
